'use strict'

module.exports = {
	'company': {
		'name': 'EasyTitle24.com',
		'emails': [
			{
				'primary': true,
				'type': 'WORK',
				'address': 'customer.service@easytitle24.com'
			}
		],
		'phones': [
			{
				'primary': true,
				'type': 'WORK',
				'number': '259-4068',
				'_areaCode': '415',
				'_countryCode': '1'
			}
		],
		'addresses': [
			{
				'_country': 'USA',
				'postalCode': '94611',
				'stateText': 'California',
				'cityText': 'Oakland',
				'line1': '654 Oakland Ave.',
				'primary': true,
				'type': 'WORK'
			}
		]
	},
	'estimator': {
		'resid': {
			'newBuildingBase': 500,
			'newBuildingPerFoot': 0.23,
			'newBuildingSelfServe': 249,
			'multiFamilyBase': 550,
			'uniqueUnitType': 125,
			'exstPlusAdtnBase': 500,
			'exstPlusAdtnPerFoot': 0.23,
			'exstPlusAdtnSelfServe': 299,
			'adtnOnlyBase': 350,
			'adtnOnlyBasenew': 375,
			'adtnOnlyPerFoot': 0.6,
			'adtnOnlySelfServe': 249,
			'estmOffset': 50
		},
		'comm': {
			'newBuildingBase': 500,
			'exstPlusAdtnBase': 500,
			'prescAppr': {
				'1': 177,
				'2': 425,
				'3': 288
			},
			'perfApprTrigger': 701,
			'perfAppr': {
				'1': 285,
				'3': 365
			},
			'estmOffset': 50
		}
	}
}



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/services/mock-data/config.js